import { useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';

const useNavbarMobileAnimation = () => {
  const [showModal, setShowModal] = useState(false);
  const pathname = usePathname();
  const router = useRouter();

  const toggleModal = () => {
    setShowModal((prev) => !prev);
  };

  const handleScroll = (id: string) => {
    setTimeout(() => {
      const element = document.querySelector(`[data-id="${id}"]`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleNavigation = (targetSection: string) => {
    if (pathname === '/') {
      handleScroll(targetSection);
    } else {
      router.push(`/#${targetSection}`);
    }
  };

  const modalVariants = {
    hidden: { y: '-100vh' },
    visible: {
      y: 0,
      transition: { type: 'tween', duration: 0.3 },
    },
    exit: {
      y: '-100vh',
      transition: { type: 'tween', duration: 0.3 },
    },
  };

  return {
    showModal,
    toggleModal,
    handleNavigation,
    modalVariants,
  };
};

export default useNavbarMobileAnimation;
